/* eslint-disable react/jsx-no-useless-fragment */
import type { ReactNode } from 'react';
import React from 'react';

type OnProps<T> = {
  // eslint-disable-next-line react/no-unused-prop-types
  value: T[];
  children: ReactNode;
};

function On<T>({ children }: OnProps<T>) {
  return <>{children}</>;
}

type MatchProps<T> = {
  value: T;
  children: ReactNode;
};

function Match<T>({ value, children }: MatchProps<T>) {
  const filteredChildren = React.Children.toArray(children).filter(
    (cmp: React.ReactElement<OnProps<T>>) => {
      if (!cmp?.props?.value || typeof value !== 'string') return false;
      return cmp.props.value.includes(value);
    }
  ) as React.ReactElement<OnProps<T>>[];

  return <>{filteredChildren}</>;
}

Match.On = On;

export { Match };
